import styled from "styled-components/macro";

export const StyledCardStack = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    background-color: var(--container-color);
    border-radius: 24px;
    width: calc(100% - 48px - 15px);
    &.full-width {
      box-sizing: border-box;
      // width: calc(100% - 30px);
      width: 100%;
      background: transparent;
      padding: 0px 15px 20px 15px;
      .hide-button {
        display: block !important;
        text-align: center;
        /* background: var(--container-color); */
        width: fit-content;
        margin: auto;
        /* padding: 10px 20px; */
        border-radius: 20px;
        font-weight: 500;
        button {
          background: transparent !important;
          padding: 0px !important;
          color: var(--grey-1) !important;
          margin: 0px !important;
        }
      }
    }
    margin-top: 27px !important;
    margin-bottom: 0px !important;
    .hide-button {
      display: none !important;
    }
    .card {
      line-height: 130%;
      h3 {
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: 700;
      }
      p {
        font-size: 16px;
        color: var(--grey-1);
        font-weight: 500;
        line-height: 137%;
      }
      a {
        font-size: 16px;
        float: right;
        font-weight: 500;
        cursor: pointer;
        padding: 7px 14px 9px 14px;
        border-radius: 19px;
      }
      img {
        width: 100%;
        border-radius: 10px;
        border: 1px solid var(--grey-2);
      }
      padding: 15px 7px 7px 10px;
      border-radius: 18px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
      // box-shadow: var(--default-drop-shadow);
      background: var(--menu-color);
      color: var(--grey-0);
      // width: calc(100% - 28px) !important;
      box-sizing: border-box;
      width: 100%;
      .orange {
        color: #ee8f00;
        background-color: #ee8f001a;
        /* background-color: #fff0d2; */
      }
      .red {
        color: #ea4713;
        background-color: #ea47131a;
        /* background-color: #ffded3; */
      }
      .primary {
        color: var(--primary-cta-high-contrast);
        background-color: var(--primary-cta-translucent);
        /* background-color: #ede2ff; */
      }
      .rainbow1 {
        color: #17abcc;
        background-color: #17abcc1a;
        /* background-color: #ddf9ff; */
      }
      .rainbow2 {
        color: #18c6a6;
        background-color: #18c6a61a;
        /* background-color: #d6fff7; */
      }
      .rainbow3 {
        color: #10bc5f;
        background-color: #10bc5f1a;
        /* background-color: #d0ffe6; */
      }
      .rainbow4 {
        color: #4dc017;
        background-color: #4dc0171a;
        /* background-color: #d6ffc2; */
      }
      .rainbow5 {
        color: #61bc08;
        background-color: #61bc081a;
        /* background-color: #d8ffb1; */
      }
    }
  }
`;
